// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchBar_searchWrapper__UGRg8"};